/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCallComment200Response
 */
export interface UpdateCallComment200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCallComment200Response
     */
    modified?: boolean;
}

/**
 * Check if a given object implements the UpdateCallComment200Response interface.
 */
export function instanceOfUpdateCallComment200Response(value: object): value is UpdateCallComment200Response {
    return true;
}

export function UpdateCallComment200ResponseFromJSON(json: any): UpdateCallComment200Response {
    return UpdateCallComment200ResponseFromJSONTyped(json, false);
}

export function UpdateCallComment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCallComment200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'modified': json['modified'] == null ? undefined : json['modified'],
    };
}

export function UpdateCallComment200ResponseToJSON(json: any): UpdateCallComment200Response {
    return UpdateCallComment200ResponseToJSONTyped(json, false);
}

export function UpdateCallComment200ResponseToJSONTyped(value?: UpdateCallComment200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modified': value['modified'],
    };
}

